import { useState } from "react";

export function useOffset() {
  return useState(0);
}
